import actions from './actions';
import mutations from './mutations';
import types from './types';
import state from './state';

export default {
  actions,
  mutations,
  types,
  state: () => state,
};
